import "./Portfolio.scss";

export default function Portfolio() {
  return (
    <section className="portfolio--section" id="MyPortfolio">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Work</p>
          <h2 className="section--heading">Work Gallery</h2>
        </div>
      </div>


       {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row ">
            <div class="col-md-5">
              <img
                src="../../../img/wg1.jpg"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Delivery (Last-Mile Delivery)</h4>
                <p class="card-text">
                  The driver or delivery personnel transports the parcel to its final destination. The parcel is delivered directly to the recipient's address,
                   with proof of delivery (signature, photo, or GPS timestamp) collected. This is often the most time-sensitive and customer-facing step.
                </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}


                 {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-5">
              <img
                src="../../../img/wg2.jpg"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Loading (Dispatch and Vehicle Loading)</h4>
                <p class="card-text">
                 Parcels are grouped by delivery route and loaded onto delivery vehicles (vans, trucks, bikes, etc.). Scanners are used to confirm each item being loaded,
                  ensuring the correct packages are assigned to the right routes. Proper loading minimizes damage and improves delivery efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}


                 {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-5">
              <img
                src="../../../img/wg3.jpeg"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Storage (Warehouse Handling)</h4>
                <p class="card-text">
                  Parcels arrive at a central warehouse or distribution center where they are scanned, sorted, and temporarily stored.
                   Each package is organized based on its destination and delivery priority. This step ensures efficient tracking and reduces errors in the dispatch process.
                </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}


                 {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-5">
              <img
                src="../../../img/wg4.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Carpet Installation (Laying and Stretching)</h4>
                <p class="card-text">
                 The carpet is unrolled, positioned, and cut to fit the room. It is then stretched using specialized tools to remove wrinkles and ensure a smooth surface. 
                 The edges are secured with grippers or tacks, and seams are joined using heat tape or adhesive for a seamless look.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}


                 {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-5">
              <img
                src="../../../img/wg5.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Finishing (Trimming and Clean-Up)</h4>
                <p class="card-text">
                  Excess carpet around edges is trimmed for a neat fit. Door bars or thresholds are installed,
                   and any final adjustments are made. The area is vacuumed, and all tools and waste are cleared away, leaving the space clean and the carpet ready for use.
                   </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}

                 {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-5">
              <img
                src="../../../img/wg6.jpg"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Deep Carpet Cleaning</h4>
                <p class="card-text">
                 The carpet is cleaned using a chosen method—commonly hot water extraction (steam cleaning), 
                 dry cleaning, or shampooing. This step removes embedded dirt, allergens, and stains. Machines or manual tools are used depending on the method.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}

                 {/* card-start */}
       <div class="portfolio-card mb-3">
          <div class="row">
            <div class="col-md-5">
              <img
                src="../../../img/wg7.webp"
                className="card-img"
                alt="..."
              />
            </div>
            <div class="col-md-7">
              <div class="card-body">
                <div className="content">
                <h4 class="card-title">Office Cleaning</h4>
                <p class="card-text">
                  A general surface-level clean of the office space, typically done daily or regularly. This includes wiping down desks, 
                  emptying bins, dusting surfaces, vacuuming or sweeping floors, and sanitizing high-touch areas like door handles, keyboards,
                   and phones. It maintains a tidy, hygienic work environment and supports employee health and productivity.
                </p>
                </div>
              </div>
            </div>
          </div>
        </div>
                {/* card-end */}

     
       
    </section>
  );
}
